var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1433.2 378.3",
    style: {
      enableBackground: "new 0 0 1433.2 378.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3,286.7v-240h24.5V160L157.3,46.7h31.3L76.8,162.5l121,124.2h-32l-118-120v120H23.3z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.2,46.7h32.5l82.7,240h-25.5l-20.2-58.2H250.2L230,286.7h-25.5L287.2,46.7z M258,205.5h90.7L303.2,74.2L258,205.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.7,166.7c0-73.8,38.8-125,110.5-125c55.7,0,91.5,30.8,104.7,78.8l-25,6.5c-10.2-37.8-36.7-61.8-79.7-61.8 c-56.3,0-84.2,41.5-84.7,101.5c-0.3,60,28.3,101.5,84.7,101.5c43,0,69.5-24,79.7-61.8l25,6.5c-13.2,48-49,78.8-104.7,78.8 C444.5,291.7,405.7,240.5,405.7,166.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M723.5,46.7H756l82.7,240h-25.5L793,228.5H686.5l-20.2,58.2h-25.5L723.5,46.7z M694.3,205.5H785L739.5,74.2L694.3,205.5 z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M912.5,286.7V70.2h-83.8V46.7h192.2v23.5H937v216.5H912.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.5,286.7v-240h24.5V160l109.5-113.3h31.3L1101,162.5l121,124.2h-32l-118-120v120H1047.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1311.3,46.7h32.5l82.7,240H1401l-20.2-58.2h-106.5l-20.2,58.2h-25.5L1311.3,46.7z M1282.2,205.5h90.7l-45.5-131.3 L1282.2,205.5z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9f4e68c4fc9715d2ab4fef846f003a08.svg";
export { ForwardRef as ReactComponent };